/**
 * @file
 * @prettier
 */

import { customValidationInit, aspControlValidationInit } from "@/common/validation/init.js";

export function InitializePaymentInstructionsDefaultPage() {
  customValidationInit(false);
  aspControlValidationInit();

  //  -----------------------------------------------------------------------------------------------------------------
  // only allow one checkbox to be checked at a time in the Single Loan repeater
  // The group of checkboxes behaving as a radio button list have the classname treatCBasRB2 to identify them.
  //  -----------------------------------------------------------------------------------------------------------------
  $(".treatCBasRB input[type='checkbox']").click(function (e) {
    // -----------------------------
    // uncheck all the checkboxes
    // -----------------------------
    $(".treatCBasRB input[type='checkbox']").prop("checked", false);
    // ---------------------------------------------------------
    // check the checkbox that is associated with this event
    // ---------------------------------------------------------
    $(this).prop("checked", true);
  });

  // @ts-ignore Hack for aspx page direct use -- A.M. 2025-09-09
  window.isPrincipalOnlyChecked = isPrincipalOnlyChecked;
}

function isPrincipalOnlyChecked() {
  var cbYes = $("[id*='cbPrincipalOnlyYes']");
  var cbNo = $("[id*='cbPrincipalOnlyNo']");
  var lblYesNoCheckBoxes = $("[id$='lblYesNoCheckBoxes']");
  var gary = $(".treatCBasRB input[type='checkbox']");

  // verify that both boxes are not checked
  if (cbYes.is(":checked")) {
    if (cbNo.is(":checked")) {
      lblYesNoCheckBoxes.validationEngine(
        "showPrompt",
        "Only one checkbox can be selected.",
        "error",
        "topLeft",
        false,
      );
      return false;
    }
  }

  // verify that on box is checked
  if (cbYes.is(":checked")) {
    return true;
  } else {
    if (cbNo.is(":checked")) {
      return true;
    } else {
      lblYesNoCheckBoxes.validationEngine("showPrompt", "One checkbox has to be selected.", "error", "topLeft", false);
      return false;
    }
  }
  return false;
}
